
import Vue from 'vue'
import moment from 'moment'

Vue.filter('card-format', (value) => {
  if (!value) return ''
  return value.replace(/\D/g, '').replace(/(....)(?=.)/g, '$1 ')
})

// {{ addtime | time }}
Vue.filter('time', function (input) {
  // 注意：获取到的是秒，转成毫秒
  return moment(input * 1000).format('YYYY-MM-DD HH:mm:ss')
})
